import React from "react";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
	Tooltip,
} from "@heroui/react";

function MixToolTip(props) {
	return isMobile() ? (
		<Popover>
			<PopoverTrigger>{props.children}</PopoverTrigger>
			<PopoverContent>{props.content}</PopoverContent>
		</Popover>
	) : (
		<Tooltip content={props.content}>{props.children}</Tooltip>
	);
}

export default MixToolTip;
